export default __webpack_public_path__ + "static/media/FeaturedCompanyTitle.6ef1e298.png";